import { jsx } from 'react/jsx-runtime';
import { ReactComponent as SvgCross } from '../../assets/icons/sign/cross.svg.js';
import COLORS from '../../constants/colors.js';
import IconWrapper from '../IconWrapper/IconWrapper.js';
import styled from 'styled-components';
import { flexCenter } from '../../mixins/style-mixins.js';
import '../../mixins/scrollbar.js';
import '../../mixins/cursor.js';
import '../../mixins/font.js';

const CloseIconWrapper = styled.div `
    ${flexCenter}
    display: inline-flex;
    background-color: ${COLORS.GREY_200};
    border-radius: 50%;
    width: 32px;
    height: 32px;
    cursor: pointer;
`;
const CloseButton = ({ onClick }) => {
    return (jsx(CloseIconWrapper, Object.assign({ onClick: onClick }, { children: jsx(IconWrapper, { children: jsx(SvgCross, { fill: COLORS.GREY_900 }) }) })));
};

export { CloseIconWrapper, CloseButton as default };
//# sourceMappingURL=CloseButton.js.map
